import { AccessibilitySettingsTabWrapper as AccessibilitySettingsTab } from '../components/settings-drawer/AccessibilitySettingsTab';
import { AudioSettingsTabWrapper as AudioSettingsTab } from '../components/settings-drawer/AudioSettingsTab';
import { BackgroundSettingsTabWrapper as BackgroundSettingsTab } from '../components/settings-drawer/BackgroundSettingsTab';
import { SettingsDrawerTab, TabMap } from '../components/settings-drawer/SettingsDrawer';
import { VideoSettingsTabWrapper as VideoSettingsTab } from '../components/settings-drawer/VideoSettingsTab';
import { SelfVideoThumbnail } from './SelfVideoThumbnail';

export const tabMap: TabMap = {
  [SettingsDrawerTab.VIDEO]: <VideoSettingsTab thumbnailComponent={SelfVideoThumbnail} />,
  [SettingsDrawerTab.AUDIO]: <AudioSettingsTab />,
  [SettingsDrawerTab.BACKGROUND]: <BackgroundSettingsTab />,
  [SettingsDrawerTab.ACCESSIBILITY]: <AccessibilitySettingsTab />,
};

export function getSupportedTabs({ isVirtualBackgroundSupported }: { isVirtualBackgroundSupported?: boolean } = {}) {
  const supportedTabs = { ...tabMap };
  if (!isVirtualBackgroundSupported) {
    delete supportedTabs[SettingsDrawerTab.BACKGROUND];
  }
  return supportedTabs;
}
